// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-notice[data-v-74742f52]{color:#dc3545}.layout-right[data-v-74742f52]{display:flex;justify-content:end}", ""]);
// Exports
module.exports = exports;
